<!-- 登记设置 -->
<template>
    <div class="app-container">
        <!-- <div class="detailsTitle">
            <h4>登记设置</h4>
        </div> -->
        <div class="searchBox" ref="searchBox" >
            <el-form class="demo-form-inline" :model="searchFrom" ref="searchFrom" label-width="110px" size="mini"
                :rules="rules">
                <div class="" style="padding: 20px 0 0 0;">
                    <el-form-item label="登记时段：" required>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item prop="startTime">
                                    <el-time-picker format="HH:mm:ss" :disabled="flag" value-format="HH:mm:ss"
                                        v-model="searchFrom.startTime" ref="menuTree" placeholder="选择时间"
                                        style="width:110px">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                &nbsp;&nbsp;至&nbsp;&nbsp;
                            </el-col>
                            <el-col :span="6">

                                <el-form-item prop="todayTomorrow">
                                    <el-select v-model="searchFrom.todayTomorrow" :disabled="flag" ref="menuTree"
                                        style="width:90px" @change="option">
                                        <el-option label="当日" value="1"></el-option>
                                        <el-option label="次日" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            &nbsp;&nbsp;
                            <el-col :span="6">
                                <el-form-item prop="endTime">
                                    <el-time-picker format="HH:mm:ss" :disabled="flag" value-format="HH:mm:ss"
                                        :picker-options="{
                                            selectableRange: `${searchFrom.startTime && searchFrom.todayTomorrow == 1 ? searchFrom.startTime : '00:00:00'} - 23:59:59`
                                        }" v-model="searchFrom.endTime" placeholder="选择时间" style="width:110px">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="围栏名称:" prop="vehicleFenceId">
                        <el-select placeholder="请选择" :disabled="flag" v-model="searchFrom.vehicleFenceId"
                            style="width:365px">
                            <el-option v-for="item in wlList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登记启用:" prop="state" style="margin-top:20px;">
                        <el-radio v-model="searchFrom.state" :disabled="flag" label="1">开启</el-radio>
                        <el-radio v-model="searchFrom.state" :disabled="flag" label="2">关闭</el-radio>
                    </el-form-item>
                    <div style="margin:40px 0 0 30px;">
                        <el-button type="primary" @click="successFn(1)" btnCode="01K0070100" v-if="btnFlg[0] && !flag">保
                            存</el-button>
                        <el-button type="primary" @click="successFn(2)" btnCode="01K0070200" v-if="btnFlg[1] && flag">编
                            辑</el-button>
                        <el-button type="primary" @click="searchFn" :disabled="flag" btnCode="01K0070300" v-if="btnFlg[2]">取
                            消</el-button>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import { getRegistrationSetting, tmsList, editRegistrationSetting } from '@/api/lj'
export default {
  data () {
    return {
      h: 500,
      flag: false,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      wlList: [],
      searchFrom: {
        state: '1',
        vehicleFenceId: '',
        vehicleFenceName: '',
        id: '',
        startTime: '',
        todayTomorrow: '',
        endTime: ''
      },

      rules: {
        state: [
          { required: true, message: '请选择登记启用', trigger: ['blur', 'change'] }
        ],
        vehicleFenceId: [
          { required: true, message: '请选择围栏名称', trigger: ['blur', 'change'] }
        ],
        todayTomorrow: [
          { required: true, message: '请选择登记时段', trigger: ['blur', 'change'] }
        ],
        startTime: [
          { required: true, message: '请选择登记时段', trigger: ['blur', 'change'] }
        ],
        endTime: [
          { required: true, message: '请选择登记时段', trigger: ['blur', 'change'] }
        ]

      },
      btnFlg: [],
      btnIdArr: ['01K0070100', '01K0070200', '01K0070300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/registrationSettings')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {

    option () {
      // this.searchFrom.endTime = ''
      this.$set(this.searchFrom, 'endTime', '')
    },
    successFn (val) {
      let that = this
      that.$refs.searchFrom.validate((valid) => {
        if (valid) {
          // 当日
          if (that.searchFrom.todayTomorrow == 1 && that.searchFrom.endTime == that.searchFrom.startTime) {
            DonMessage.error('结束时间不能与开始时间一致')
            return
          }
          // 保存
          if (val == 1) {
            const loading = that.$loading({
              lock: true,
              text: '正在处理...'
            })
            let result = that.wlList.find((item) => {
              return item.id == that.searchFrom.vehicleFenceId
            })
            that.searchFrom.vehicleFenceName = result.name
            editRegistrationSetting(that.searchFrom).then(res => {
              DonMessage.success('保存成功')
              loading.close()
              that.searchFrom = {}
              that.getList()
            }).catch(err => {
              loading.close()

              DonMessage.error(err.message)
            })
          } else {
            that.flag = false
            // 修改
            // let result = that.wlList.find((item) => {
            //     return item.id == that.searchFrom.vehicleFenceId
            // })
            // that.searchFrom.vehicleFenceName = result.name
            // editRegistrationSetting(that.searchFrom).then(res => {
            //     DonMessage.success('修改成功')
            //     loading.close()
            //     that.searchFrom = {}
            //     that.getList()
            // }).catch(err => {
            //     loading.close()
            //     DonMessage.error(err.message)
            // })
          }
        }
        // that.getList()
      })
    },
    destroy () {
      this.drawerFlag = false
    },

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      getRegistrationSetting(this.searchFrom).then(res => {
        this.searchFrom = {}
        if (res == null) {
          this.$set(this.searchFrom, 'state', '1')
          this.flag = false
          this.$refs.searchFrom.clearValidate()
        } else {
          let obj = { ...res }
          this.$set(this.searchFrom, 'state', obj.state)
          this.$set(this.searchFrom, 'vehicleFenceId', obj.vehicleFenceId)
          this.$set(this.searchFrom, 'vehicleFenceName', obj.vehicleFenceName)
          this.$set(this.searchFrom, 'id', obj.id)
          this.$set(this.searchFrom, 'startTime', obj.startTime)
          this.$set(this.searchFrom, 'endTime', obj.endTime)
          this.$set(this.searchFrom, 'todayTomorrow', obj.todayTomorrow)
          // this.searchFrom.state = obj.state
          // this.searchFrom.vehicleFenceId = obj.vehicleFenceId
          // this.searchFrom.vehicleFenceName = obj.vehicleFenceName
          // this.searchFrom.id = obj.id
          // this.searchFrom.startTime = obj.startTime
          // this.searchFrom.todayTomorrow = obj.todayTomorrow
          // this.searchFrom.endTime = obj.endTime
          this.flag = true
        }
      }).catch(err => {
        DonMessage.error(err.message)
      })
      tmsList({
        pageNo: 1,
        pageSize: 9999,
        status: 1
      }).then(res => {
        this.wlList = res.list
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {}
      this.$set(this.searchFrom, 'state', '1')
      // this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
    margin-left: 10px;
}

// /deep/ .el-form-item__content {
//     position: relative;
//     margin-bottom: 30px;
// }
/deep/.el-input.is-disabled .el-input__inner {

    color: #000000;
}

/deep/ .inpBox.el-input__inner {
    width: 180px !important;
}
</style>
